import React, { useState, useEffect, useRef } from 'react';

import { Button, Space, Modal, Select, InputNumber, message, Popconfirm, Switch, Spin } from 'antd';

import SPMapFenceModal from 'modals/carRental/SPMapFenceModal';

import request  from '../../../../request'
import { API_STORE_SERVICE_SCOPE_LIST,API_STORE_SERVICE_SCOPE_CHANGE } from '../../../../hooks/carRental/_'

import SPEditTable from '../SPEditTable'
import SPTimeRangePicker from '../../../base/SPTimeRangePicker'

import emiter, {
  EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL,
  EVENT_CARRENTAL_EDITTABLE_ADDROW,
  EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL
} from '../../../../events'
import { cloneDeep } from 'lodash';

import { serviceAreaAddOrUpdate } from 'hooks/carRental/store';
import SPButton from "../../base/SPButton";

const DoorstepFee: React.FC<{value?:any,onChange?:any}> = ({value,onChange}) => {
  const [type, setType] = useState(value?.type || false);
  const [inputValue, setInputValue] = useState<any>(value?.value);

  const onChangeType = (value: any) => {

    const newVal = value ? 1 : 2;
    setType(newVal);

    if (newVal === 2) {
      setInputValue('');
      onChange({
        value:'',
        type: newVal
      })
    } else {
      onChange({
        value:inputValue,
        type: newVal
      })
    }
  };
  return (
    <Space>
      {/* <Select
        placeholder="请选择"
        onChange={onChangeType}
        defaultValue={type}
      >
        <Select.Option value={1}>是</Select.Option>
        <Select.Option value={2}>否</Select.Option>
      </Select> */}
      <Switch checked={type === 1} onChange={onChangeType} />
      <InputNumber
        style={{ width: '90%' }}
        step={1}
        precision={0}
        min={0}
        max={999}
        disabled={type === 2} onChange={
        (value: any) => {
          setInputValue(value);
          onChange({
            value,
            type
          })
        }
      } value={inputValue} />
    </Space>
  );
}

const BookingTime: React.FC<{value?:any,onChange?:any}> = ({value,onChange}) => {

  const [type, setType] = useState(value?.type || 2);

  const onChangeType = (typeValue: any) => {
    setType(typeValue);
    onChange({
      value:value?.value,
      type:typeValue
    })
  };
  return (
    <Space>
      <InputNumber
        style={{ width: '100%' }}
        step={1}
        precision={0}
        min={1}
        max={100}
        value={value?.value}
        onChange={(value1:any) => {
          onChange({ value: value1, type })
        }}
      />
      <Select
        placeholder="请选择"
        defaultValue={type}
        onChange={onChangeType}
      >
        <Select.Option value={1}>分钟</Select.Option>
        <Select.Option value={2}>小时</Select.Option>
      </Select>
    </Space>
  );
}

interface PropsType {
  enums?: any;
  permission?: any;
}


const SPServiceScopeModal: React.FC<PropsType> = (props) => {
  const [open, setOpen] = useState(false);
  const [mapFenceModalVisible, setMapFenceModalVisible] = useState(false);
  const [polygons, setPolygons] = useState<any>([]);
  const [extraPolygons, setExtraPolygons] = useState<any>([]);
  const [targetRecord, setTargetRecord] = useState<any>({});
  const storeInfo = useRef<any>({});
  const [mapType, setMapType] = useState('');
  const { permission } = props;
  const [isLoading, setIsLoading] = useState<boolean>(true);


  const DeleteBtn = (props: any) => (
    <>
      <Popconfirm
        title="确定删除吗"
        onConfirm={() => handleServiceScopeDelete(props?.id, props?.code)}
        okText="确定"
        cancelText="取消"
      >
        <SPButton permission={permission} permissionKey='store_service_area_add_or_update' style={{ padding: '0 3px' }} type="link">删除</SPButton>
      </Popconfirm>
    </>
  );

  const FreeSelect = (props: any) => (
    <Select
      placeholder="请选择"
      style={{ width: '100%' }}
      defaultValue={props.value}
      onChange={(value) => props?.onChange(value) }
    >
      <Select.Option value={1}>是</Select.Option>
      <Select.Option value={2}>否</Select.Option>
    </Select>
  );

  const commonColumns = [
    {
      title: '区域名称',
      dataIndex: 'area_name',
      formItemProps: {
        rules: [
          {
            required: true,
            whitespace: true,
            message: '请输入区域名称',
          },
        ],
      },
    },
  ]
  const doorstepFeeColumn = {
    dataIndex: 'doorstepFee',
    formItemProps: {
      rules: [
        {
          required: true,
          message: '请选择送车上门费用',
          validator: (rule: any, value: any, callback: any) => {
            if (!value) {
              callback('该项为必填项');
            } else if (value?.type === 1 && (typeof value?.value !== 'number' || !(value?.value >= 0))) {
              callback('该项为必填项');
            } else {
              callback();
            }
          }
        },
      ],
    },
    renderFormItem: () => {
      return (
        <DoorstepFee />
      );
    },
    render: (_: any, row: any) => {
      return row.doorstepFee?.type === 1 ? `${row.doorstepFee?.value}元` : <Switch checked={false} />;
    }
  };
  const pickColumns: any = [
    ...commonColumns,
    {
      title: '提前预定时间',
      dataIndex: 'pre_booking_time',
      formItemProps: {
        rules: [
          {
            required: true,
            message: '请输入提前预定时间',
            validator: (rule: any, value: any, callback: any) => {
              if (!value?.type || !value?.value) {
                callback('请输入提前预定时间');
              } else {
                callback();
              }
            }
          },
        ],
      },
      renderFormItem: () => {
        return (
          <BookingTime />
        );
      },
      render: (_: any, row: any) => {
        return `${row.pre_booking_time?.value}${row.pre_booking_time?.type === 1 ? '分钟' : '小时'}`;
      }
    },
    {
      title: '服务时间',
      dataIndex: 'serviceTime',
      formItemProps: {
        rules: [
          {
            required: true,
            message: '请选择服务时间',
            validator: (rule: any, value: any, callback: any) => {
              if (!value?.startTime || !value?.endTime) {
                callback('请选择服务时间');
              } else {
                callback();
              }
            }
          },
        ],
      },
      renderFormItem: () => {
        return (
          <SPTimeRangePicker startName="startTime" endName="endTime"/>
        );
      },
      render: (_: any, row: any) => {
        return `${row.serviceTime?.startTime} - ${row.serviceTime?.endTime}`;
      }
    },
    {
      ...(doorstepFeeColumn || {}),
      title: '送车上门/收费（元）'
    },
    {
      title: '免费接用户到门店取车',
      dataIndex: 'free',
      formItemProps: {
        rules: [
          {
            required: true,
            message: '请选择是否免费接用户到门店取车',
          },
        ],
      },
      renderFormItem: () => (<FreeSelect />),
      render: (_: any, row: any) => {
        return row.free === 1 ? '是' : '否';
      }
    },
    {
      title: '操作',
      valueType: 'option',
      width: 100,
      render: (text:any, record:any, _:any, action:any) => [
      <SPButton
        type="link"
        key="editable"
        style={{ padding: '0 3px' }}
        onClick={() => {
          action?.startEditable?.(record.id);
        }}
      >
        编辑
      </SPButton>,
      <Button type="link" style={{ padding: '0 3px' }} onClick={() => handleAreaDraw(record, 'pick')}>绘制区域</Button>,
      <SPButton
        type="link"
        key="copy"
        style={{ padding: '0 3px' }}
        onClick={()=>onCopyToReturn(record)}
      >
        复制此项到还车区域
      </SPButton>,
      <DeleteBtn id={record.id} code={record.service_area_code} />
    ],
    },
  ];

  const returnColumns: any = [
    ...commonColumns,
    {
      title: '服务时间',
      dataIndex: 'serviceTime',
      formItemProps: {
        rules: [
          {
            required: true,
            message: '请选择服务时间',
            validator: (rule: any, value: any, callback: any) => {
              if (!value?.startTime || !value?.endTime) {
                callback('请选择服务时间');
              } else {
                callback();
              }
            }
          },
        ],
      },
      renderFormItem: () => {
        return (
          <SPTimeRangePicker startName="startTime" endName="endTime"/>
        );
      },
      render: (_: any, row: any) => {
        return `${row.serviceTime?.startTime} - ${row.serviceTime?.endTime}`;
      }
    },
    {
      ...(doorstepFeeColumn || {}),
      title: '上门取车/收费（元）',
    },
    {
      title: '还车后免费送用户到预定目的地',
      dataIndex: 'free',
      formItemProps: {
        rules: [
          {
            required: true,
            message: '请选择',
          },
        ],
      },
      renderFormItem: () => (<FreeSelect />),
      render: (_: any, row: any) => {
        return row.free === 1 ? '是' : '否';
      }
    },
    {
      title: '操作',
      valueType: 'option',
      width: 100,
      render: (text:any, record:any, index:any, action:any) => [
      <Button
        type="link"
        key="editable"
        onClick={() => {
          action?.startEditable?.(record.id);
        }}
      >
        编辑
      </Button>,
      <Button type="link" onClick={() => handleAreaDraw(record, 'return')}>绘制区域</Button>,
      <DeleteBtn id ={record.id} code={record.service_area_code} />
    ],
    },
  ];

  const [pickData, setPickData] = useState<any>([]);
  const [returnData, setReturnData] = useState<any>([]);
  const [storeData, setStoreData] = useState<any>();


  const formatData = (data: any) => {
    const {
      area_name, service_area_code, to_door_service, service_fee, polygon,
      pre_booking_time, pre_booking_time_unit, open_time, end_time, shuttle_service_type
    } = data || {};

    const item: any = {
      id: service_area_code,
      service_area_code,
      area_name,
      pre_booking_time: { value: pre_booking_time || '', type: pre_booking_time_unit || '' },
      serviceTime: { startTime: open_time || '', endTime: end_time || '' },
      free: shuttle_service_type,
      polygon,
      doorstepFee: { type: to_door_service || 1, value: to_door_service === 1 ? service_fee / 100 : '' }
    }
    return item;
  }

  const formatParams = (data: any, isPick?: boolean) => {
    const { area_name, pre_booking_time, serviceTime, doorstepFee, free, id, service_area_code, polygon } = data || {};
    const target: any = {
      id,
      service_area_code,
      area_name,
      open_time: serviceTime?.startTime,
      end_time: serviceTime?.endTime,
      shuttle_service_type: free,
      polygon: polygon || [],
      to_door_service: doorstepFee?.type,
    }
    if (isPick) {
      target.pre_booking_time = pre_booking_time?.value;
      target.pre_booking_time_unit = pre_booking_time?.type;
    }
    target.service_fee = doorstepFee?.type === 1 ? (doorstepFee.value || 0) * 100 : 0;
    return target;
  }

  const loadData = (data: any) => {
    setIsLoading(true);
    request({
      url: API_STORE_SERVICE_SCOPE_LIST,
      method: 'GET',
      params: {
        store_code: data.store_code
      }
    }).then((res: any) => {
      const { data } = res || {};
      const pList = (data.pickup_list || []).map((item: any) => formatData(item));
      const rList = (data.return_list || []).map((item: any) => formatData(item));
      setPickData(pList);
      setReturnData(rList);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }

  const onOpen = (data: any) => {
    // drawer打开的同时去更改状态，所以关闭drawer
    // emiter.emit(EVENT_TRAVEL_CLOSE_DRAWER_PLAN);
    setStoreData(data);
    setOpen(true);
    loadData(data);
    storeInfo.current = data;
  };

  const onClose = () => {
    setPickData([]);
    setReturnData([]);
    setExtraPolygons([]);
    setOpen(false);
  };

  const onCopyToReturn = (data: any) => {
    emiter.emit(EVENT_CARRENTAL_EDITTABLE_ADDROW, cloneDeep(data));
  };

  const delDataDeal = (id: any) => {
    const newPickUpData = cloneDeep(pickData);
    const newReturnData = cloneDeep(returnData);
    (newPickUpData || []).forEach((item: any, index: number) => {
      if (item.id === id) {
        newPickUpData.splice(index, 1);
      }
    });
    (newReturnData || []).forEach((item: any, index: number) => {
      if (item.id === id) {
        newReturnData.splice(index, 1);
      }
    });
    setPickData(newPickUpData);
    setReturnData(newReturnData);
  }

  const handleServiceScopeDelete = (id: any, code: any) => {
    if (code) {
      serviceAreaAddOrUpdate({
        store_code: storeData?.store_code,
        del_list: [code],
      }).then((res: any) => {
        delDataDeal(id);
      });
    } else {
      delDataDeal(id);
    }
  }

  const handleAreaDraw = (record: any, type: string) => {
    setPolygons(record?.polygon?.length ? [record?.polygon] : []);
    const areas = type === 'pick' ? pickData : returnData;
    const extraArea = (areas || []).filter(((item: any) => item.polygon && item.id !== record.id)).map((item: any) => item.polygon);
    setExtraPolygons(extraArea);
    setMapFenceModalVisible(true);
    setTargetRecord(record);
    setMapType('');
  }

  const updateData = (data: any, type: any) => {
    const newPickData = cloneDeep(pickData);
    const newReturnData = cloneDeep(returnData);

    if (type === '用户取车时') {
      const idx = newPickData.findIndex((item: any) => item.id === data.id);
      if (idx !== -1) {
        newPickData.splice(idx, 1, data);
        setPickData(newPickData);
      } else {
        setPickData([...newPickData, data]);
      }
    } else {
      const idx = newReturnData.findIndex((item: any) => item.id === data.id);
      if (idx !== -1) {
        newReturnData.splice(idx, 1, data);
        setReturnData(newReturnData);
      } else {
        setReturnData([...newReturnData, data]);
      }
    }
  }

  const handleAreaPreview = (polygons: any) => {
    setPolygons(polygons);
    setMapFenceModalVisible(true);
    setMapType('view');
  }

  const handleFenceModalOk = (polygons: any) => {
    setPolygons(polygons || []);
    setMapFenceModalVisible(false);
    const newPickUpData = cloneDeep(pickData);
    const newReturnData = cloneDeep(returnData);
    newPickUpData.forEach((item: any) => {
      if (item.id === targetRecord.id) {
        item.polygon = polygons;
      }
    });
    newReturnData.forEach((item: any) => {
      if (item.id === targetRecord.id) {
        item.polygon = polygons;
      }
    });
    setPickData(newPickUpData);
    setReturnData(newReturnData);
  }

  const handleFenceModalClose = () => {
    setPolygons([]);
    setMapFenceModalVisible(false);
  }

  const onFinish = () => {
    request({
      url: API_STORE_SERVICE_SCOPE_CHANGE,
      method: 'POST',
      data: {
        pickup_list: (pickData || []).map((item: any) => formatParams(item, true)),
        return_list: (returnData || []).map((item: any) => formatParams(item)),
        del_list: [],
        store_code:storeData.store_code
      }
    }).then(() => {
      onClose();
      message.success('操作成功');
    });
  };

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL, onOpen);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL)
    }
  }, []);

  return (
    <>
      <Modal title="送取车服务区域配置" destroyOnClose open={open} onOk={onFinish} onCancel={onClose} width={1200} forceRender>
        <Spin spinning={isLoading}>
          <SPEditTable
            columns={pickColumns}
            value={pickData}
            title="用户取车时"
            formatData={formatData}
            onUpdateData={updateData}
            onPreview={handleAreaPreview}
          />
          <SPEditTable
            columns={returnColumns}
            value={returnData}
            title="用户还车时"
            formatData={formatData}
            onUpdateData={updateData}
            onPreview={handleAreaPreview}
          />
        </Spin>
      </Modal>
      <SPMapFenceModal
        type={mapType}
        visible={mapFenceModalVisible}
        polygons={polygons}
        extraPolygons={extraPolygons}
        position={{
          lng: +storeInfo?.current?.longitude,
					lat: +storeInfo?.current?.latitude,
        }}
        onOk={handleFenceModalOk}
        onClose={handleFenceModalClose}
      />
    </>
  );
}

export default React.memo(SPServiceScopeModal);
